import axios from 'axios';
import { markSaved } from './leaveGuard';

// Attach the session token (admin or tech — both stored as authToken) to every
// backend request, and bounce to the right login page when a session is
// rejected. Installed on the global axios instance plus any dedicated
// instances (e.g. crmBackendService's client).

function attachAuth(config) {
  const token = localStorage.getItem('authToken');
  if (token && !config.headers?.Authorization) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}

function handleAuthError(error) {
  if (error.response?.status === 401) {
    const role = localStorage.getItem('userRole');
    localStorage.removeItem('authToken');
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('techAuthenticated');
    const loginPath = role === 'tech' ? '/tech' : '/';
    if (window.location.pathname !== loginPath) {
      window.location.assign(loginPath);
    }
  }
  return Promise.reject(error);
}

export function installAuthInterceptor(instance) {
  instance.interceptors.request.use(attachAuth);
  instance.interceptors.response.use((r) => {
    // A successful save means nothing on screen is unsaved any more (leave-page warning).
    if (!['get', 'head', 'options'].includes((r.config?.method || 'get').toLowerCase())) markSaved();
    return r;
  }, handleAuthError);
}

// Cover every raw `axios.get/post(...)` call site in the app
installAuthInterceptor(axios);
